import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import Grid from '../../../components/grid';
import InlineLink from '../../../components/inline-link';
import UnstyledButton from '../../../components/unstyled-button';

const gridItemStyles = `
  &:first-of-type {
    grid-column: span 7;
  }

  ${screen.below(bp.mobile, `
    &:nth-of-type(-n+2) {
      grid-column: 1 / -1;
    }

    &:nth-of-type(3) {
      grid-column: 1 / span 1;
    }

    &:last-of-type {
      grid-column: 2 / -1;
      justify-self: end;
    }
  `)};
`;

const ColumnWrapper = ({ onClick, link, children, ...rest }) => {

  if (link) {
    return (
      <InlineLink href={link} {...rest}>
        {children}
      </InlineLink>
    );
  } else if (onClick) {
    return (
      <UnstyledButton onClick={onClick} {...rest}>
        {children}
      </UnstyledButton>
    );
  }

  return (
    <StyledSpan {...rest}>
      {children}
    </StyledSpan>
  );
};

const AccountDetailGridRow = ({ data }) => (
  <DetailGrid cols={19}>
    {data.map((cell, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Grid.Item span={4} styles={gridItemStyles} key={i}>
        <ColumnWrapper link={cell.link} onClick={cell.onClick} styles={cell.styles}>
          {cell.content}
        </ColumnWrapper>
      </Grid.Item>
    ))}
  </DetailGrid>
);

const DetailGrid = styled(Grid)`
  padding: 18px 0 22px;
  align-items: center;
  font-size: ${rem(16)};
  border-bottom: 1px solid #3e3e3e;

  a,
  button {
    color: ${props => props.theme.blue};
    text-decoration: underline;

    &:focus {
      outline: none;
      color: #fff;
    }
  }

  ${screen.below(bp.mobile, `
    grid-template-columns: repeat(2, 1fr);
  `)};

  ${screen.below(bp.mobileSm, `
    padding: 10px 0;
  `)};
`;

const StyledSpan = styled.span`
  ${props => props.styles && css`
      ${props.styles}
  `}
`;

AccountDetailGridRow.propTypes = {
  data: PropTypes.array,
};

export default AccountDetailGridRow;
